import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// A file is required to be in the root of the /src directory by the TypeScript compiler

export function promptHyperlinks() {
  alert("promptHyperlinks");
}
export function resetCoords() {
  alert("resetCoords");
}

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
ReactDOM.render(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
